import React, { useState } from "react";
import { Check } from "lucide-react";
import { STEP_TONE, WAITS, doneLine, waitsOf } from "../../lib/groupJourney";

/** The row's "Etapa" cell (29.10.2026): the steps, what happens next, who it waits for. */
export function JourneyCell({ row }) {
  const [open, setOpen] = useState(false);
  if (!row) return <span className="text-[11px] text-[#6B7280]">—</span>;
  const { steps, summary } = row;
  const waits = waitsOf(summary.waits);
  const current = steps.find((s) => s.key === summary.step);
  return (
    <div className="grid min-w-[240px] gap-1.5" data-testid="journey-cell">
      <button type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open}
        className="flex flex-wrap items-center gap-1 text-left" title={open ? "Ascunde pașii" : "Vezi toți pașii"}>
        {steps.map((s) => (
          <span key={s.key} title={`${s.label}: ${s.text}`}
            className="inline-flex items-center gap-1 rounded-full bg-[#F5F6F6] py-0.5 pl-0.5 pr-2 text-[10px] font-semibold text-[#373A45]">
            <span className={`inline-flex h-3.5 w-3.5 items-center justify-center rounded-full ${STEP_TONE[s.state] || STEP_TONE.later}`}>
              {s.state === "done" && <Check size={9} strokeWidth={3} />}
            </span>
            {s.label}{s.note ? <span className="font-normal text-[#6B7280]">· {s.note}</span> : null}
          </span>
        ))}
      </button>
      <p className="text-xs text-[#373A45]">{summary.text}</p>
      <div className="flex flex-wrap items-center gap-1.5">
        <span className={`inline-flex rounded-full px-2 py-0.5 text-[10px] font-semibold ${waits.tone}`}>{waits.label}</span>
        {summary.urgent && (
          <span className="inline-flex rounded-full bg-[#E63946] px-2 py-0.5 text-[10px] font-semibold text-white">urgent</span>
        )}
      </div>
      {current?.detail?.length > 0 && (
        <ul className="list-disc pl-4 text-[11px] text-[#b42a35]">
          {current.detail.map((d) => <li key={d}>{d}</li>)}
        </ul>
      )}
      {open && (
        <ol className="grid gap-1 border-l-2 border-[#E5E7EB] pl-2 text-[11px] text-[#6B7280]" data-testid="journey-steps">
          {steps.map((s) => (
            <li key={s.key}><strong className="text-[#373A45]">{s.label}:</strong> {s.text}</li>
          ))}
        </ol>
      )}
    </div>
  );
}

/** Above the table: how many have done each step, and the filters by who a row waits for. */
export function JourneySummary({ journey, filter, onFilter }) {
  if (!journey?.total) return null;
  const chip = (key, label, n) => (
    <button key={key || "all"} type="button" onClick={() => onFilter(key)} aria-pressed={filter === key}
      className={`rounded-full border px-2.5 py-1 text-[11px] font-semibold ${filter === key
        ? "border-[#965EA7] bg-[#965EA7]/10 text-[#7A4986]" : "border-[#E5E7EB] bg-white text-[#373A45] hover:bg-[#F5F6F6]"}`}
      data-testid={`journey-filter-${key || "all"}`}>
      {label}{n != null ? ` (${n})` : ""}
    </button>
  );
  return (
    <div className="mb-3 grid gap-2" data-testid="journey-summary">
      <p className="text-xs text-[#6B7280]">{doneLine(journey)}</p>
      <div className="flex flex-wrap gap-1.5">
        {chip("", "Toți", null)}
        {WAITS.map((w) => chip(w.key, w.label, journey.counts?.[w.key] ?? 0))}
      </div>
    </div>
  );
}
